//on documaent loaded
document.addEventListener("DOMContentLoaded", function() {
  //Lightbox

  //get webform-trigger element
  var webformTriggers = document.querySelectorAll(".webform-trigger");
  //if webformTrigger exists

  //loop through all webformTriggers
  webformTriggers.forEach(function(webformTrigger) {
    if (webformTrigger) {
      //on click
      webformTrigger.addEventListener("click", function() {
        //get attribute data-webform
        var webformId = this.getAttribute("data-webform");
        //get data-demand
        var demand = this.getAttribute("data-demand");
        //if textarea with name input_14 exist
        var textarea = document.querySelector('textarea[name="input_14"]');
        var fileContainerField = document.querySelector("div#field_3_15");
        // if (webformId == "plan") {
        //   //hide fileContainer
        //   fileContainerField.style.display = "none";
        // } else {
        //   fileContainerField.style.display = "block";
        // }

        if (textarea) {
          //set value of textarea to demand
          textarea.value = demand;
        } else {
          textarea.value = "";
        }
      });
    }
  });
});
